module.exports = __webpack_public_path__ + "static/media/productos_otros_jamaica.64f3a0bc.png";